
import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import UserOne from '../../../assets/images/user/user.png';
import { APP_URLS } from '../../../config';
import { useSelector } from 'react-redux';
import { userDetailsSelector } from '../../../rdxsga/redux/slices/userSlice';
import { useDarkMode } from '../../../rdxsga/hooks/common/useDarkMode';
import { Button, IconButton, Tooltip } from '@material-tailwind/react';
import { LogoutOutlined } from '@mui/icons-material';
import { IoIosNotificationsOutline } from "react-icons/io";
import RightDrawer from './RightDrawer';
import { useNotificationSocket } from '../../../context/NotificationSocketProvider';


const DropdownUser = ({ handleLogout, openDrawerRight }) => {

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const user = useSelector(userDetailsSelector);

  const darkMode = useDarkMode();

  const { notification } = useNotificationSocket();


  const trigger = useRef(null);
  const dropdown = useRef(null);

  // close on click outside
  // useEffect(() => {
  //   const clickHandler = ({ target }) => {
  //     if (!dropdown.current) return;
  //     if (
  //       !dropdownOpen ||
  //       dropdown.current.contains(target) ||
  //       trigger.current.contains(target)
  //     )
  //       return;
  //     setDropdownOpen(false);
  //   };
  //   document.addEventListener('click', clickHandler);
  //   return () => document.removeEventListener('click', clickHandler);
  // });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });


  // useEffect(() => {
  //   //console.log(Object.keys(newMessage).length)
  //   Object.keys(newMessage).length > 0 && //console.log({ newMessage });
  // }, [newMessage])


  return (
    <div className="w-full flex items-center">
      <IconButton
        variant='text'
        className='mr-3 relative'
        onClick={openDrawerRight}
      // className={`p-0 ${sidebarOpen || "ml-[50px]"} `}
      >
        <IoIosNotificationsOutline className='text-2xl' />
        {
          notification?.length > 0 && (
            <>
              <div className='absolute h-4 w-5 text-xs font-bold text-white rounded-full -top-1 -right-1 bg-red-900'>{notification?.length > 99 ? "99+" : notification.length}</div>
              {/* <div className='absolute h-4 w-4 text-xs font-bold text-white rounded-full -top-1 -right-2 bg-red-900 animate-ping'>{notification?.length}</div> */}
            </>
          )
        }
      </IconButton>
      <Tooltip content="Profile">
        <Link
          ref={trigger}
          onClick={() => setDropdownOpen(!dropdownOpen)}
          className="flex items-center gap-4"
          to={APP_URLS.PROFILE}
        >
          <span className="hidden text-right lg:block">
            <span className="block text-sm font-medium text-black dark:text-white">
              {`${user?.user?.user?.firstName} ${user?.user?.user?.middleName} ${user?.user?.user?.lastName}`}
            </span>
          </span>
        </Link>
      </Tooltip>

      <Tooltip content="Logout">
        <Button
          onClick={handleLogout}
          className='ms-3 py-1 px-3'
          color='red'
          size='sm'>
          <LogoutOutlined
            fontSize='small'
            className='text-white'
          />
        </Button>
      </Tooltip>



    </div>
  );
};

export default DropdownUser;
